import React, {
  useCallback,
  useEffect,
  useState,
  useMemo, useRef
} from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Button } from 'devextreme-react';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import CheckBox from 'devextreme/ui/check_box';
import { format } from 'date-fns';
import { formatMessage } from 'devextreme/localization';
import notify from 'devextreme/ui/notify';
import { isOne, trim } from '../../../utils/functions';
import PopupMVP from '../../PopupMVP';
import PopupErrorMVP from '../../PopupErrorMVP';
import DataGridMVP from '../../DataGridMVP';
import HeaderButtonMVP from '../../HeaderButtonMVP';

import columnDataGrid from './columnDataGrid';
import columnDataGridRecyclingM15B from './columnDataGridRecyclingM15B';
import columnDataGridConsignment from './columnDataGridConsignment';
import columnDataM15 from './columnDataM15';
import columnDataTranspOrder from '../columnDataTranspOrder';
import columnDataProjectNum from '../columnDataProjectNum';
import columnDataIMZGP from './columnDataIMZGP';
import columnDataNotGP from '../columnDataNotGP';
import columnDataGridAdditionalSemi from './columnDataGridAdditionalSemi';
import columnDataSemiAttrb from '../columnDataSemiAttrb';
import columnDataTN from '../columnDataTN';

const Shipment = ({
  settingsReducer: { settings },
  shipmentReducer: {
    listShipment,
    loading,
    loadingData,
    okRequest,
    okUpdate,
    okConsignment,
    error,
    okList
  },
  tabsReducer: { tabSelect },
  userReducer: {
    id,
    permissions
  },
  getProcessingStartCancel,
  getProcessingStartClear,
  getShipment,
  getShipmentActRemoveM15B,
  getShipmentErrorClear,
  isReadyStock,
  isRecyclingOrdersEnabled,
  isUseBuyoutWithTtn,
  isUseCheckShiptoAddress,
  isUseM15B,
  isUseM4,
  plantId,
  modalErrorOpen,
  modalProcessingStartOpen,
  modalShipmentPlanCancelOpen,
  modalShipmentPlanReadyOpen,
  modalShipmentRedeemConsignmentOpen,
  modalShipmentSZRebindingOpen,
  modalSKZipOpen,
  showTranspOrder
}) => {
  /** фильтры из localStorage */
  const localTemp = JSON.parse(localStorage.getItem(`dataGridShipmentRecycling${plantId}`));

  /** Данные по таблице */
  const [thisDataGridInstance, setThisDataGridInstance] = useState({});
  /**
   * Переменная для определения текущего рендера списка,
   * где 0 = первый рендер или очистка фильтра
   */
  const isListMounted = useRef(0);

  /** Модальки / свойство */
  const [modalData, setModalData] = useState({
    visibleSubmerg: false,
    visibleNotSubmerg: false
  });
  /** Фильтры по таблице */
  const [filterDataGrid, setFilterDataGrid] = useState({
    dateFrom: '',
    dateTo: '',
    filter: localTemp ? localTemp.searchText : '',
    statusId: null
  });

  /** Сохранение фильтров для сравнения изменений перед запросом */
  const prevFilterDataGrid = useRef(filterDataGrid);

  const [selectItem, setSelectItem] = useState([]);
  // Выбранные элементы списка
  const [checked, setChecked] = useState([]);

  /** Сохранение выбранных элементов для передачи в запрос,
   * чтобы не реагировать на каждое изменение checked */
  const prevCheckedRef = useRef(checked);

  /** Стейт обновлены ли поля для изменения ширины */
  const [isFieldsUpdate, setIsFieldUpdate] = useState(false);

  useEffect(() => {
    if (tabSelect === 0) {
      isListMounted.current = 0;
    }
  }, [tabSelect]);

  // изменение переменной после получения списка
  useEffect(() => {
    if (okList) {
      isListMounted.current += 1;
    }
  }, [okList]);

  // Сохранение выбранных элементов текущей вкладки в хранилище
  useEffect(() => {
    if (tabSelect === 0) {
      window.localStorage.setItem('checkedItems', JSON.stringify(checked.map(({ pieceNumId, qcId, actualPieceId, cgId }) => ({ pieceNumId, qcId, actualPieceId, cgId }))));
    } else {
      window.localStorage.removeItem('checkedItems');
    }
  }, [checked, tabSelect]);

  /** Проверка формы */
  // const [isValid, setIsValid] = useState(1);
  // const [isFocusItems, setIsFocusItems] = useState({
  //   data: false,
  //   mh3: false
  // });

  /** Видимость поля при селекте строчек */
  const [headButtVisibol, setHeadButtVisibol] = useState({ display: 'none' });

  /** Выбор строк */
  const [dataSource, setDataSource] = useState({
    count: [0, 0],
    listSubmerge: '',
    listNotSubmerge: '',
    listSubmergeItems: [],
    selectSubmergeItems: [],
    selectNotSubmergeItems: [],
    listActRemoveM15B: [], /* Список УЕ где надо очистить акт мх3 */
    stringActRemoveM15B: '',
    stringActRemoveM15BDop: '',
    selectRejectText: '',
    itemAcceptMh3: '',
    itemAcceptDate: '',
    skData: {
      count: 0,
      data: {}
    }
  });

  /** Видимость кнопок - Отгрузка, Отмена отгрузки, Перепривязка СЗ */
  const [visibleBtn, setVisibleBtn] = useState({
    btnShipping: false,
    btnShippingCancel: false,
    btnRebinding: false
  });

  useEffect(() => {
    if (permissions.length) {
      setVisibleBtn({
        btnShipping: permissions.indexOf('btnShipping') !== -1,
        btnShippingCancel: permissions.indexOf('btnShippingCancel') !== -1,
        btnRebinding: settings.useSZRebinding
          && permissions.indexOf('prmChangeSO') !== -1
      });
    }
  }, [isReadyStock, permissions, settings.useSZRebinding]);

  /** Всплывающие сообщения об ошибке */
  useEffect(() => {
    if (error) {
      modalErrorOpen({
        message: error.message || '',
        techInfo: error.techInfo || '',
        types: 'error'
      });
      getShipmentErrorClear();
    }
  }, [error, getShipmentErrorClear, modalErrorOpen]);

  const countPlan = useMemo(() => {
    const temp = selectItem.filter(
      (item) => (item.psStatusNumId === 0
          || item.psStatusNumId === 2)
        && !item.onHoldFlag
    ).length;
    if (temp) {
      setHeadButtVisibol({ display: 'flex' });
    } else {
      setHeadButtVisibol({ display: 'none' });
    }
    return temp;
  }, [selectItem]);

  /** Фильтрация в переменные
   *  по статусу "В пути" - 0 + "В наличии" - 2 / psStatusNumId и hasShippingPlan */
  const countCanselPlan = useMemo(() => {
    const temp = selectItem.filter(
      (item) => item.hasShippingPlan === true
        && (item.psStatusNumId === 0 || item.psStatusNumId === 2)
        && !item.onHoldFlag
    ).length;
    return temp;
  }, [selectItem]);

  /** Всплывающая подсказка */
  useEffect(() => {
    if (okRequest) {
      notify(
        {
          message: formatMessage('dataSuccess'),
          height: 64,
          width: 354,
          position: {
            at: 'top center',
            my: 'top center',
            offset: '0 48'
          }
        },
        'success',
        2000
      );
      thisDataGridInstance.instance.clearSelection();
      setModalData({ visibleSubmerg: false, visibleNotSubmerg: false });
    }
  }, [okRequest, thisDataGridInstance]);

  useEffect(() => {
    prevCheckedRef.current = checked;
  }, [checked]);

  useEffect(() => {
    if (tabSelect !== 0 || id === null) return;

    const prevChecked = prevCheckedRef.current;

    if (okUpdate) {
      getShipment({
        ...filterDataGrid,
        plantId,
        items: prevChecked.map(({ pieceNumId }) => pieceNumId)
      });
      thisDataGridInstance.instance.clearSelection();
      return;
    }

    // после загрузки таблицы ссылка на объект фильтров меняется,
    // и получается, что предыдущие и текущие фильтры не равны
    const isFilterActive = Object.values(filterDataGrid).filter(Boolean).length;
    const filtersChanged = prevFilterDataGrid.current !== filterDataGrid;

    // если фильтры изменились
    if (filtersChanged) {
      getShipment({
        ...filterDataGrid,
        plantId,
        items: prevChecked.map(({ pieceNumId }) => pieceNumId)
      });

      return;
    }

    // если это первый рендер и фильтры пустые
    if (isListMounted.current === 0 && !isFilterActive) {
      getShipment({
        ...filterDataGrid,
        plantId,
        items: []
      });
    }

    isListMounted.current += 1;
    prevFilterDataGrid.current = filterDataGrid;
  }, [
    tabSelect,
    id,
    okUpdate,
    filterDataGrid,
    plantId,
    getShipment,
    thisDataGridInstance.instance
  ]);

  /** Анимация загрузки данных */
  useEffect(() => {
    if (thisDataGridInstance.instance) {
      if (loadingData) {
        thisDataGridInstance.instance.beginCustomLoading('Loading...');
      } else {
        thisDataGridInstance.instance.endCustomLoading();
      }
    }
  }, [loadingData, thisDataGridInstance]);

  /** Функция закрытия модальки */
  const modalOnHiding = useCallback(() => {
    setModalData({
      visibleSubmerg: false,
      visibleNotSubmerg: false
    });
    // setIsValid(1);
    getProcessingStartClear();
  }, [
    getProcessingStartClear
  ]);

  const onClickButtonNotSubmerge = useCallback(() => {
    if (
      isOne(
        selectItem.filter(
          (item) => dataSource.selectNotSubmergeItems.indexOf(item.pieceNumId) >= 0
        ),
        'plantId',
        Number(plantId)
      )
    ) {
      setModalData({
        ...modalData,
        visibleNotSubmerg: true
      });
    } else {
      modalErrorOpen({
        message: formatMessage('textError').differentWarehousesSelected,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    }
  }, [
    dataSource.selectNotSubmergeItems,
    modalData,
    modalErrorOpen,
    plantId,
    selectItem
  ]);

  /** Функция открытия модальки на переработку */
  const onClickButtonSubmerge = useCallback(() => {
    setModalData({
      ...modalData,
      visibleSubmerg: true
    });
    if (
      isOne(
        dataSource.selectSubmergeItems,
        'plantId',
        Number(plantId)
      )
    ) {
      modalProcessingStartOpen({
        plantId,
        selectList: dataSource.selectSubmergeItems
      });
    } else {
      modalErrorOpen({
        message: formatMessage('textError').differentWarehousesSelected,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    }
  }, [
    modalData,
    dataSource.selectSubmergeItems,
    plantId,
    modalProcessingStartOpen,
    modalErrorOpen
  ]);

  /** Функция открытия модальки на выкуп */
  const onClickButtonBuyOut = useCallback(() => {
    let tempBooleanZeroWeightRemain = false;
    let tempStringQCZeroWeightRemain = '';

    setModalData({
      ...modalData,
      visibleSubmerg: true
    });
    if (dataSource.selectSubmergeItems.length === 1) {
      const tempData = dataSource.selectSubmergeItems[0];

      if (isUseBuyoutWithTtn && (tempData.l4SoId == null || tempData.l4SoId === '')) {
        modalErrorOpen({
          message: `${formatMessage('textModal').textIncomingNoSoDescrLeft} ${tempData.qcId} ${formatMessage('textModal').textIncomingNoSoDescrRight}`,
          techInfo: '',
          types: 'info',
          title: formatMessage('textError').warning
        });
        return;
      }
      if (tempData.psStatusNumId === 8
          && (tempData.weightRemain === null || tempData.weightRemain === 0)) {
        tempBooleanZeroWeightRemain = true;
        tempStringQCZeroWeightRemain = tempData.qcId;
      }
      setDataSource({
        ...dataSource,
        itemAcceptMh3: dataSource.selectSubmergeItems[0].mh3,
        itemAcceptDate: format(new Date(), 'yyyy-MM-dd')
      });
    }
    if (dataSource.selectSubmergeItems.length > 1) {
      const tempData = dataSource.selectSubmergeItems[0];
      let l4SoIdEmpty = false;

      dataSource.selectSubmergeItems.forEach((item) => {
        if (isUseBuyoutWithTtn && (item.l4SoId == null || item.l4SoId === '')) {
          l4SoIdEmpty = true;
        }
        if (item.psStatusNumId === 8
          && (item.weightRemain === null || item.weightRemain === 0)) {
          tempBooleanZeroWeightRemain = true;
          tempStringQCZeroWeightRemain = tempStringQCZeroWeightRemain ? `${tempStringQCZeroWeightRemain}, ${item.qcId}` : item.qcId;
        }
        if (tempData.mh3 !== item.mh3) {
          tempData.mh3 = '';
        }
      });
      if (l4SoIdEmpty) {
        modalErrorOpen({
          message: `${formatMessage('textModal').textIncomingNoSoDescrLeft} ${tempData.qcId} ${formatMessage('textModal').textIncomingNoSoDescrRight}`,
          techInfo: '',
          types: 'info',
          title: formatMessage('textError').warning
        });
        return;
      }
      setDataSource({
        ...dataSource,
        itemAcceptMh3: tempData.mh3,
        itemAcceptDate: format(new Date(), 'yyyy-MM-dd')
      });
    }
    if (tempBooleanZeroWeightRemain) {
      modalErrorOpen({
        message: `${formatMessage('textModal').textZeroWeightRemainErrorLeft} ${tempStringQCZeroWeightRemain}, ${formatMessage('textModal').textZeroWeightRemainErrorRight}`,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
      return;
    }
    if (
      isOne(
        dataSource.selectSubmergeItems,
        'plantId',
        Number(plantId)
      )
    ) {
      if (
        isOne(
          dataSource.selectSubmergeItems,
          'shiptoAddressSo',
          0
        ) || !isUseCheckShiptoAddress
      ) {
        modalShipmentRedeemConsignmentOpen({
          plantId,
          selectSubmergeItems: dataSource.selectSubmergeItems,
          listSubmergeItems: dataSource.listSubmergeItems
        });
      } else {
        modalErrorOpen({
          message: formatMessage('textError').differentShiptoAddressSo,
          techInfo: '',
          types: 'info',
          title: formatMessage('textError').warning
        });
      }
    } else {
      modalErrorOpen({
        message: formatMessage('textError').differentWarehousesSelected,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    }
  }, [
    modalData,
    dataSource,
    plantId,
    isUseBuyoutWithTtn,
    modalErrorOpen,
    isUseCheckShiptoAddress,
    modalShipmentRedeemConsignmentOpen
  ]);

  const onClickSZRebinding = useCallback(() => {
    modalShipmentSZRebindingOpen({
      plantId,
      selectList: dataSource.selectSubmergeItems,
      filter: filterDataGrid
    });
  }, [dataSource.selectSubmergeItems, modalShipmentSZRebindingOpen, plantId, filterDataGrid]);

  /** Событие на выделение строк */
  const dataGridOnSelection = useCallback((selectedRowsData, component, dataSourceDop) => {
    if (selectedRowsData.length) {
      setChecked(selectedRowsData);
      const temp = [0, 0];
      let listSubmerge = '';
      let listNotSubmerge = '';
      const selectSubmergeItems = [];
      const listSubmergeItems = [];
      const selectNotSubmergeItems = [];
      const rowsToDeselect = [];
      const listActRemoveM15B = [];
      let stringActRemoveM15B = '';
      let stringActRemoveM15BDop = '';
      const arrayActRemoveM15BDop = [];
      let prover = false;
      const skData = {
        count: 0,
        data: {}
      };
      setSelectItem(selectedRowsData);
      selectedRowsData.forEach((item) => {
        skData.count += 1;
        skData.data[item.qcId] = { qcShop: item.qcShopCode, qcDate: item.accountingDate };

        if (item.onHoldFlag) {
          rowsToDeselect.push(item.pieceNumId);
          modalErrorOpen({
            message: `${formatMessage('textModal').textIncomingHoldLeft} ${item.qcId} ${formatMessage('textModal').textIncomingHoldRight}`,
            techInfo: '',
            types: 'info',
            title: formatMessage('textError').warning
          });
        } else {
          // eslint-disable-next-line no-lonely-if
          if (item.psStatusNumId === 2
            || (item.psStatusNumId === 8 && settings.stockType)) { // в наличии
            temp[0] += 1;
            listSubmerge += `${item.cgId} ${item.actualPieceId}; `;
            selectSubmergeItems.push(item);
            listSubmergeItems.push(item.pieceNumId);
            prover = true;
            /* Проверка на наличие акта */
            if (item.m15b && item.m15b !== '') {
              listActRemoveM15B.push(item.pieceNumId);
              stringActRemoveM15B += `${item.cgId} ${item.actualPieceId}; `;
              if (arrayActRemoveM15BDop.indexOf(`${item.m15b}`) === -1) {
                stringActRemoveM15BDop += `${item.m15b} ${format(new Date(item.m15bDate), 'dd.MM.yyyy')}; `;
                arrayActRemoveM15BDop.push(`${item.m15b}`);
              }
            }
          } else if (item.psStatusNumId === 8) { // в переработке
            temp[1] += 1;
            listNotSubmerge += `${item.cgId} ${item.actualPieceId}; `;
            selectNotSubmergeItems.push(item.pieceNumId);
            prover = true;
          } else if (item.psStatusName === 'В пути') {
            rowsToDeselect.push(item.pieceNumId);
          }
        }
      });
      if (rowsToDeselect.length) {
        component.deselectRows(rowsToDeselect);
      }
      setDataSource({
        ...dataSourceDop,
        count: temp,
        listSubmerge,
        listNotSubmerge,
        listSubmergeItems,
        selectSubmergeItems,
        selectNotSubmergeItems,
        listActRemoveM15B,
        stringActRemoveM15B,
        stringActRemoveM15BDop,
        skData
      });
      if (prover) {
        setHeadButtVisibol({ display: 'flex' });
      }
    } else {
      window.localStorage.removeItem('checkedItems');
      setDataSource({
        ...dataSourceDop,
        count: [0, 0],
        skData: {
          count: 0,
          data: {}
        }
      });
      setHeadButtVisibol({ display: 'none' });
      setChecked([]);
    }
  }, [modalErrorOpen, settings]);

  /** Функция на обработку чекбоксов неактивными */
  const onCellPrepared = useCallback((e) => {
    if (e.rowType === 'data' && e.column.command === 'select' && e.data.psStatusName === 'В пути') {
      const instatnce = CheckBox.getInstance(e.cellElement.querySelector('.dx-select-checkbox'));
      instatnce.option('disabled', true);
      e.cellElement.style.pointerEvents = 'none';
    }
  }, []);

  /** Поисковая строка */
  const dataGridOnOptionChanged = useCallback(({ value, name }) => {
    if (name === 'searchPanel') {
      if (!value) {
        isListMounted.current = 0;
      }
      setFilterDataGrid({ ...filterDataGrid, filter: value });
    }
  }, [filterDataGrid]);

  /** Событие на закрыть */
  const closeHeaderButtom = useCallback(() => {
    thisDataGridInstance.instance.clearSelection();
    setHeadButtVisibol({ display: 'none' });
    setChecked([]);
  }, [thisDataGridInstance.instance]);

  /** Отправка отмены переработки */
  const sendNotSubmerg = useCallback(() => {
    // if (/* dataSource.selectRejectText !== '' && dataSource.selectRejectText !== null */ true) {
    getProcessingStartCancel({
      items: dataSource.selectNotSubmergeItems,
      plantId
    });
    // setIsValid(1);
    thisDataGridInstance.instance.clearSelection();
    modalOnHiding();
    // }
    // else {
    //   setIsValid(0);
    // }
    // eslint-disable-next-line
  }, [plantId, dataSource]);

  /** Удаление УЕ из акта мх3 */
  const [visibleModalErrorActRemoveM15B, setVisibleModalErrorActRemoveM15B] = useState(false);
  const onClickButtonActRemoveM15B = useCallback(() => {
    setVisibleModalErrorActRemoveM15B(true);
  }, []);
  const onHidingModalErrorActRemoveM15B = useCallback(() => {
    setVisibleModalErrorActRemoveM15B(false);
  }, []);
  const onModalErrorOnClickButtonYesActRemoveM15B = useCallback(() => {
    getShipmentActRemoveM15B({ items: dataSource.listActRemoveM15B, plantId });
    setVisibleModalErrorActRemoveM15B(false);
  }, [dataSource.listActRemoveM15B, getShipmentActRemoveM15B, plantId]);

  // Групповое скачивание СК
  const onClickButtonSK = useCallback(() => {
    modalSKZipOpen({
      data: dataSource.skData.data,
      plantId
    });
  }, [
    dataSource.skData.data,
    modalSKZipOpen,
    plantId
  ]);

  const onClickPlanCancel = useCallback(() => {
    modalShipmentPlanCancelOpen({
      selectList: selectItem
        .filter(
          (item) => item.hasShippingPlan === true
            && (item.psStatusNumId === 0 || item.psStatusNumId === 2)
        )
    });
  }, [modalShipmentPlanCancelOpen, selectItem]);

  const onClickPlan = useCallback(() => {
    modalShipmentPlanReadyOpen({
      plantId,
      selectItems: selectItem
        .filter((item) => item.psStatusNumId === 0 || item.psStatusNumId === 2)
        .map((iitem) => iitem.pieceNumId),
      items: selectItem
    });
  }, [modalShipmentPlanReadyOpen, plantId, selectItem]);

  const renderColumnsDataGrid = useMemo(() => (
    columnDataGrid.map(
      (item) => {
        if (item.dataField === 'widthFact' && !settings.useMC) {
          return null;
        }

        return (
          <Column dataField={item.dataField}
                  caption={formatMessage('textTable')[item.dataField]}
                  visible={!item.notVisible}
                  allowSearch={false}
                  allowFiltering
                  cellRender={item.cellRender}
                  key={item.dataField}
                  dataType={item.dataType}
                  cssClass={item.cssClass}
          />
        );
      }
    )
  ), [settings.useMC]);

  const renderColumnDataGridConsignment = useMemo(() => (
    columnDataGridConsignment.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnDataGridM15 = useMemo(() => (
    columnDataM15.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnDataGridRecyclingM15B = useMemo(() => (
    columnDataGridRecyclingM15B.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnDataGridAdditionalSemi = useMemo(() => (
    columnDataGridAdditionalSemi.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').recycling[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnM15M4 = useMemo(() => (
    columnDataM15.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').M15M4[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnM15BM4 = useMemo(() => (
    columnDataGridRecyclingM15B.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').M15BM4[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnTranspOrder = useMemo(() => (
    columnDataTranspOrder.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnProjectNum = useMemo(() => (
    columnDataProjectNum.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderColumnDataIMZGP = useMemo(() => (
    columnDataIMZGP.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dateType={item.dateType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderColumnDataNotGP = useMemo(() => (
    columnDataNotGP.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dateType={item.dateType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderColumnSemiAttrb = useMemo(() => (
    columnDataSemiAttrb.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderColumnTN = useMemo(() => (
    columnDataTN.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.dataField === 'ttn' ? settings.useTtnCreate ? item.cellRender : '' : item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), [settings.useTtnCreate]);

  // Обновление данных
  const onClickUpdate = useCallback(() => {
    const isFilterActive = Object.values(filterDataGrid).filter(Boolean).length;
    getShipment({
      ...filterDataGrid,
      plantId,
      items: isFilterActive ? checked.map(({ pieceNumId }) => pieceNumId) : []
    });
  }, [filterDataGrid, getShipment, plantId, checked]);

  // Обновление данных после выкупа
  useEffect(() => {
    if (okConsignment) {
      onClickUpdate();
    }
  }, [onClickUpdate, okConsignment]);

  /** Изменение ширины полей TODO придумать что-нибудь лаконичнее */
  useEffect(() => {
    if (listShipment.length && localTemp && !isFieldsUpdate) {
      let fieldModify = false;
      let dataFieldsName = ['qcId', 'documentId', 'mh3'];
      dataFieldsName.forEach((fieldName) => {
        let controlField = {
          name: fieldName,
          maxLength: 0,
          index: 0
        };
        if (!localTemp.columns.filter((item) => item.dataField === fieldName)[0]?.width) {
          localTemp.columns.forEach((item, index) => item.dataField === fieldName ? controlField.index = index : null);
          listShipment.forEach((item) => item[fieldName]?.length * 12 > controlField.maxLength ? controlField.maxLength = item[fieldName].length * 12 : null);
          if (controlField.maxLength !== 0) {
            localTemp.columns[controlField.index].width = controlField.maxLength;
            fieldModify = true;
          }
        }
      });
      if (fieldModify) {
        localStorage.setItem(`dataGridShipmentRecycling${plantId}`, JSON.stringify(localTemp));
        setIsFieldUpdate(true);
        onClickUpdate();
      }
    }
  }, [localTemp, listShipment, isFieldsUpdate, plantId, onClickUpdate]);

  const renderDataGrid = useMemo(() => (
    <DataGridMVP dataSource={listShipment}
                 setDataGridInstance={setThisDataGridInstance}
                 onSelectionChanged={({ selectedRowsData, component }) => dataGridOnSelection(
                   selectedRowsData,
                   component,
                   dataSource
                 )}
                 filterDataGrid={filterDataGrid}
                 setFilterDataGrid={setFilterDataGrid}
                 className="shipment"
                 setStateStoringName={`dataGridShipmentRecycling${plantId}`}
                 onCellPrepared={onCellPrepared}
                 dataGridOnOptionChanged={dataGridOnOptionChanged}
                 tText={formatMessage('textShipmentPeriod')}
                 loadingData={loadingData}
                 onClickUpdate={onClickUpdate}
                 visibleButtonUpdate
                 // visibleButtonSelectFields
                 shrinkToolbar={headButtVisibol.display !== 'none'}
                 altWeightNettoField="virtualNetto"
                 altWeightBruttoField="virtualBrutto"
    >
      { renderColumnsDataGrid }
      { renderColumnDataGridConsignment }
      <Column dataField={'dateProcessingStart'}
              caption={formatMessage('textTable').recycling.dateProcessingStart}
              allowSearch={false}
              allowFiltering
              dataType={'string'}
      />
      { isUseM4 ? renderColumnM15M4 : renderColumnDataGridM15 }
      {/* eslint-disable-next-line no-nested-ternary */}
      { isUseM15B ? (
        isUseM4 ? renderColumnM15BM4 : renderColumnDataGridRecyclingM15B
      ) : null }
      { showTranspOrder ? renderColumnTranspOrder : null }
      { settings.stockType ? renderColumnProjectNum : null }
      { plantId === '8167' ? renderColumnDataIMZGP : null }
      { isRecyclingOrdersEnabled ? renderColumnDataGridAdditionalSemi : null }
      { settings.stockType !== 'ready' ? renderColumnDataNotGP : null }
      { settings.showSemiAttrb ? renderColumnSemiAttrb : null }
      { (settings.useTtnCreate || settings.useBuyoutWithTtn) ? renderColumnTN : null}
      { settings.useTtnCreate
        && (
          <Column dataField={'ttnDocStatusDescr'}
                  caption={formatMessage('textTable').ttnDocStatusDescr}
                  allowSearch={false}
                  allowFiltering
                  dataType={'string'}
          />
        )}
    </DataGridMVP>
  ), [
    listShipment,
    filterDataGrid,
    plantId,
    onCellPrepared,
    dataGridOnOptionChanged,
    loadingData,
    renderColumnsDataGrid,
    renderColumnDataGridConsignment,
    isUseM4,
    isUseM15B,
    renderColumnM15M4,
    renderColumnDataGridM15,
    renderColumnM15BM4,
    renderColumnDataGridRecyclingM15B,
    showTranspOrder,
    renderColumnTranspOrder,
    settings,
    renderColumnProjectNum,
    renderColumnDataIMZGP,
    renderColumnDataNotGP,
    renderColumnDataGridAdditionalSemi,
    dataGridOnSelection,
    dataSource,
    isRecyclingOrdersEnabled,
    onClickUpdate,
    headButtVisibol.display,
    renderColumnSemiAttrb,
    renderColumnTN
  ]);

  return (
    <>
      <HeaderButtonMVP headButtVisibol={headButtVisibol}>
        <Button icon="close" stylingMode="text" onClick={closeHeaderButtom} />
        <span className="span-first">{`${formatMessage('textDataGrid').selectQU}:`}</span>
        {(dataSource.count[0])
          ? (
            <>
              <span>{`“В наличии” - ${dataSource.count[0]} `}</span>
              {(!settings.stockType && visibleBtn.btnShipping)
                ? (
                  <Button text={formatMessage('textButton').processing}
                          type="default"
                          stylingMode="contained"
                          onClick={onClickButtonSubmerge}
                  />
                ) : ''}
              {(visibleBtn.btnShipping && isUseM15B)
                ? (
                  <Button text={formatMessage('textButton').buyOut}
                          type="default"
                          stylingMode="contained"
                          onClick={onClickButtonBuyOut}
                  />
                ) : ''}
              {(visibleBtn.btnShipping && isUseBuyoutWithTtn)
                ? (
                  <Button text={formatMessage('textButton').submerge}
                          type="default"
                          stylingMode="contained"
                          onClick={onClickButtonBuyOut}
                  />
                ) : ''}
              {(visibleBtn.btnShipping && dataSource.listActRemoveM15B.length > 0)
                ? (
                  <Button text={formatMessage('textButton').removeFromActM15}
                          type="default"
                          stylingMode="contained"
                          onClick={onClickButtonActRemoveM15B}
                  />
                ) : ''}
              {countPlan && isReadyStock ? (
                <Button text={`${formatMessage('textButton').loadingPlanning} - ${countPlan}`}
                        type="success"
                        stylingMode="contained"
                        onClick={onClickPlan}
                />
              ) : (
                <div />
              )}
              {countCanselPlan && isReadyStock ? (
                <Button text={`${formatMessage('textButton').cancelPlanning} - ${countCanselPlan}`}
                        type="success"
                        stylingMode="contained"
                        onClick={onClickPlanCancel}
                />
              ) : (
                <div />
              )}
            </>
          )
          : <div />}
        {(dataSource.count[1])
          ? (
            <>
              <span>{`“В переработке” - ${dataSource.count[1]} `}</span>
              {(visibleBtn.btnShipping && isUseM15B)
                ? (
                  <Button text={formatMessage('textButton').buyOut}
                          type="default"
                          stylingMode="contained"
                          onClick={onClickButtonBuyOut}
                  />
                ) : ''}
              {(visibleBtn.btnShipping && dataSource.listActRemoveM15B.length > 0)
                ? (
                  <Button text={formatMessage('textButton').removeFromActM15}
                          type="default"
                          stylingMode="contained"
                          onClick={onClickButtonActRemoveM15B}
                  />
                ) : ''}
              {(!settings.stockType && visibleBtn.btnShippingCancel)
                ? (
                  <Button text={formatMessage('textButton').cancelProcessing}
                          type="default"
                          stylingMode="contained"
                          onClick={onClickButtonNotSubmerge}
                  />
                ) : ''}
            </>
          )
          : <div />}
        {(!settings.stockType && dataSource.skData.count
          ? (
            <>
              <Button text={formatMessage('textButton').downloadQc}
                      type="default"
                      stylingMode="contained"
                      onClick={onClickButtonSK}
              />
            </>
          )
          : <div />)}
        {(visibleBtn.btnRebinding && (
          <Button text={formatMessage('textButton').rebinding}
                  type="default"
                  stylingMode="contained"
                  onClick={onClickSZRebinding}
          />
        ))}
      </HeaderButtonMVP>
      { renderDataGrid }
      {/* Отмена переработки */}
      <PopupMVP visible={modalData.visibleNotSubmerg}
                onHiding={modalOnHiding}
                title={formatMessage('textModal').cancellationOfProcessing}
      >
        <div className="formData">
          <p>{`№ : ${dataSource.listNotSubmerge !== '' ? trim(trim(dataSource.listNotSubmerge, ' '), ';') : ''}`}</p>
          <div className="formButton">
            <Button text={formatMessage('textButton').no}
                    type="default"
                    stylingMode="text"
                    onClick={modalOnHiding}
            />
            <Button type="default"
                    stylingMode="contained"
                    useSubmitBehavior
                    width={200}
                    onClick={sendNotSubmerg}
            >
              <LoadIndicator className="indicator" visible={loading} />
              <span>{formatMessage('textButton').yesCancel}</span>
            </Button>
          </div>
        </div>
      </PopupMVP>
      {/* Модальное окно на подтверждение удаления УЕ из акта м15в */}
      <PopupErrorMVP
        visible={visibleModalErrorActRemoveM15B}
        message={`${formatMessage('textModal').deletePiece}:
        ${trim(trim(dataSource.stringActRemoveM15B, ' '), ';')}
        ${formatMessage('textModal').fromAct}: ${trim(trim(dataSource.stringActRemoveM15BDop, ' '), ';')}
        ${formatMessage('textModal').respectively}?`}
        techInfo=""
        width={600}
        types="info"
        onHiding={onHidingModalErrorActRemoveM15B}
      >
        <div className="formButton">
          <Button text={formatMessage('textButton').no}
                  type="default"
                  stylingMode="text"
                  onClick={onHidingModalErrorActRemoveM15B}
          />
          <Button type="default"
                  stylingMode="contained"
                  useSubmitBehavior
                  width={200}
                  disabled={loading}
                  onClick={onModalErrorOnClickButtonYesActRemoveM15B}
          >
            <LoadIndicator className="indicator" visible={loading} />
            <span>{formatMessage('textButton').yes}</span>
          </Button>
        </div>
      </PopupErrorMVP>
      <div />
    </>
  );
};

export default React.memo(Shipment);
